<script lang="ts">
	let open = false;

	function closeMenu() {
		open = false;
	}
	function openMenu() {
		open = true;
	}
</script>

<!-- drawer init and toggle -->
<div class="w-8 flex-col" on:click={openMenu} on:keydown={openMenu} role="presentation">
	<div class="border-t border-t-fx-grey-400 w-full" />
	<div class="border-t border-t-fx-grey-400 w-full my-2" />
	<div class="border-t border-t-fx-grey-400 w-full" />
</div>

<!-- drawer component -->
<div
	class="fixed w-2/3 bg-fx-gradient-8 {open
		? 'right-0 block'
		: '-right-2/3 hidden'} top-0 h-screen z-50 transition-right duration-500 flex flex-col p-4 justify-start items-end"
>
	<button class="text-fx-grey-200" on:click={closeMenu}>X</button>
	<div class="border-t border-t-fx-grey-600 w-full mt-2 mb-4" />
	<a
		on:click={closeMenu}
		on:keydown={closeMenu}
		href="/"
		class="text-fx-grey-300 font-medium text-sm my-2"
	>
		HOME
	</a>
	<a
		on:click={closeMenu}
		on:keydown={closeMenu}
		href="/perps"
		class="text-fx-grey-300 font-medium text-sm my-2"
	>
		PERPS
	</a>
	<a
		on:click={closeMenu}
		on:keydown={closeMenu}
		href="/strategies"
		class="text-fx-grey-300 font-medium text-sm my-2"
	>
		STRATEGIES
	</a>
	<a
		on:click={closeMenu}
		on:keydown={closeMenu}
		href="/home?section=rewards"
		class="text-fx-grey-300 font-medium text-sm my-2"
	>
		REWARDS
	</a>
	<a href="https://docs.trade.polynomial.fi/" class="text-fx-grey-300 font-medium text-sm my-2">
		DOCS
	</a>

	<div class="flex justify-end items-center mt-auto">
		<a href="https://twitter.com/polynomialfi" target="_blank" rel="noreferrer">
			<img src={'social/twitter-grey.png'} loading="lazy" alt="twitter" class="w-5 h-4 mr-8" />
		</a>
		<a href="https://discord.gg/polynomial" target="_blank" rel="noreferrer">
			<img src={'social/discord-grey.png'} loading="lazy" alt="twitter" class="w-5 h-4 mr-6" />
		</a>
		<a href="https://feedback.polynomial.fi/" target="_blank" rel="noreferrer">
			<div
				class="border border-fx-grey-500 bg-fx-grey-800 py-2 px-2 text-fx-grey-100 rounded-md text-xs"
			>
				Send feedback
			</div>
		</a>
	</div>
</div>
